import { _isMac } from './Shortcut';

export const isRightClick = (
  e: MouseEvent | React.MouseEvent,
  lastMouseDown?: MouseEvent
) => {
  // if ctrl key is held now and for the corresponding keydown, and the user has not
  // dragged at all, treat it as a right click to match standard macos behaviour
  if (
    _isMac &&
    e.button === 0 &&
    e.ctrlKey &&
    (!lastMouseDown ||
      (lastMouseDown.ctrlKey &&
        lastMouseDown.clientX === e.clientX &&
        lastMouseDown.clientY === e.clientY))
  ) {
    return true;
  }

  return e.button === 2;
};
